import { render, staticRenderFns } from "./UserPreference.vue?vue&type=template&id=833a3ed8"
import script from "./UserPreference.vue?vue&type=script&lang=js"
export * from "./UserPreference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports